import type { WhenSelection, WhereSelection, WhoSelection } from "@ui/components/SearchBar";
import { useInstantSearch } from "react-instantsearch";
import { useSearchUrlSync } from "@/hooks/use-search-url-sync";
import { serializeWhenParams, serializeWhereParams, serializeWhoParams } from "@/lib/search-params";
import type { Bbox } from "@/lib/where-bounding-boxes";
import { PROGRAMS_SEARCH_PARAM_KEYS, serializeProgramsFilterParams } from "./search-params";

interface ProgramsUrlSyncProps {
  whereValue: WhereSelection | null;
  whereBbox: Bbox | null;
  when: WhenSelection;
  who: WhoSelection;
}

/**
 * Renderless writer mirroring the programs search state into the URL.
 * Where/When/Who come in as props (they are page-local state); the modal
 * filters are read from `indexUiState` — `items` would drop a refined bucket
 * with zero hits (see ProgramsFiltersAdapter).
 */
export function ProgramsUrlSync({ whereValue, whereBbox, when, who }: ProgramsUrlSyncProps) {
  const { indexUiState } = useInstantSearch();
  useSearchUrlSync({
    params: {
      ...(whereValue && whereBbox ? serializeWhereParams({ selection: whereValue, bbox: whereBbox }) : {}),
      ...serializeWhenParams(when),
      ...serializeWhoParams(who),
      ...serializeProgramsFilterParams(indexUiState),
    },
    ownedKeys: PROGRAMS_SEARCH_PARAM_KEYS,
  });
  return null;
}
